import './BookReadStyle.css'
import { DictionaryLink, Sentence } from "../../../rest/models";
import { RenderSentenceTranslations } from "./RenderSentenceTranslations";
import { EWRSaveButton } from "./editwhilereading/EWRSaveButton";
import { EWRSentenceEditor } from "./editwhilereading/EWRSentenceEditor";
import { EWRSetBookmarkButton } from "./editwhilereading/EWRSetBookmarkButton";
import { Button } from "../../RequestRespectingInputs";
import { useState } from "react";

export function RenderSentence(props: Props)
{
    const senId = props?.sentence?.sentence_id;
    const isEditable = !props.isPreview
        && props?.sentence?.type !== 'n';

    const searchParams = new URLSearchParams(window.location.search);
    const bm0 = searchParams.get('bookmark');
    const bm = parseInt(bm0 || '0') - 1;

    const [selectedForEditing, setSelectedForEditing] = useState(false);

    const editButton = isEditable
        ? <Button className='ernots_EWREditButton' onClick={e => setSelectedForEditing(!selectedForEditing)}>
                {selectedForEditing ? 'Cancel Editing' : ' Edit'}
        </Button>
        : <></>;

    const setBookmarkButton = isEditable
        ? <EWRSetBookmarkButton sentenceId={senId}/>
        : <></>;

    const saveButton = selectedForEditing
        ? <div><EWRSaveButton/></div>
        : <></>;

    const contents = selectedForEditing
        ? <EWRSentenceEditor
            sentence={props.sentence}/>
        : <RenderSentenceTranslations
            sentence={props.sentence}
            dictLinks={props.dictLinks}/>;

    return (
    <table className='ernots_RenderSentence' data-bookmarked={bm === senId} border={1}>
        <tbody>
            <tr>
                <td className='ernots_RenderSentence_Left ernots_CenteredCell'>
                    <div className='ernots_RenderSentence_SentenceId'>
                        {senId + 1}
                    </div>
                    <br/>
                    <div className='ernots_RenderSentence_Buttons'>
                        {editButton}{saveButton}{setBookmarkButton}
                    </div>
                    
                </td>
                <td className='ernots_RenderSentence_Contents'>
                    {contents}
                </td>
            </tr>
        </tbody>
    </table>);
}

interface Props
{
    sentence: Sentence;
    dictLinks: {[language_id: string]: DictionaryLink[]};
    isPreview: boolean;
}